import { useEffect, useState } from 'react';

/** Matches the page container's `max-w-9xl` (96rem) in tailwind.config.js. */
export const LAYOUT_CONTENT_MAX_PX = 1536;

/** Viewport must exceed the layout cap by this much before present mode widens. */
export const PRESENT_EXPAND_BUFFER_PX = 120;

export function viewportAllowsPresentExpand() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth > LAYOUT_CONTENT_MAX_PX + PRESENT_EXPAND_BUFFER_PX;
}

/**
 * True when the window is wide enough that present mode can widen columns and
 * break out of the page container without stealing space from Notes.
 *
 * Below the threshold present mode still enlarges type — it just does not go
 * full-bleed, which on a normal laptop would make columns worse, not better.
 */
export function usePresentExpand(active) {
  const [expand, setExpand] = useState(() =>
    active ? viewportAllowsPresentExpand() : false,
  );

  useEffect(() => {
    if (!active) {
      setExpand(false);
      return undefined;
    }
    const update = () => setExpand(viewportAllowsPresentExpand());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [active]);

  return expand;
}
